export class CreditCardModel {
  id: string;
  mePayCardId: string;
  lastDigits: string;
  brand: number;
  type: number;
  default: boolean;

  cardId: string;
  ownerId: string;
  cardBrand: number;

  bandeira: number;
  finalNumero: string;

  constructor() {
    this.brand = 0;
    this.type = 0;
    this.cardBrand = 0;
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/models/creditCard.model.ts